import { getDatabase, ref, onValue } from "firebase/database";
import { useEffect, useState } from "react";
import Plot from 'react-plotly.js';

export function SummaryPage(props) {

    const stopListen = true;
    const tasks = ['Eat Meals', 'Go to Class', 'Study', 'Walk the Dog', 'Workout'];
    const taskDef = {'Eat Meals' : 0, 'Go to Class' : 0, 'Study' : 0, 'Walk the Dog' : 0, 'Workout' : 0};
    let aggregateTasksPerDay = {};
    const [userDailyData, setUserDailyData] = useState({});

    useEffect(() => {
        const db = getDatabase();
        const dataChange = ref(db, 'dayTracker/' + props.uid);
        const unregisterFunction = onValue(dataChange, (snapshot) => {
            setUserDailyData(snapshot.val());
        });
        function cleanup() {
            unregisterFunction();
        }
        return cleanup;
    }, [stopListen]);


    for (const date in userDailyData) {
        const aggregateData = userDailyData[date];
        aggregateTasksPerDay[date] = {...taskDef};
        for (let i = 0; i <= tasks.length; i++) {
            let currTask = tasks[i];
            for (const task in aggregateData) {
                if (task.includes(currTask) && aggregateData[task]) {
                    aggregateTasksPerDay[date][currTask] += 1;
                }
            }
        }
    }

    return (
        <div>
            <BarChart data={aggregateTasksPerDay} />
        </div>
    );
}

function BarChart(props) {

    const stackedBarChartData = props.data;
    const datesXAxis = Object.keys(stackedBarChartData);
    let eatMealsY = [];
    let goToClassY = [];
    let studyY = [];
    let walkDogY = [];
    let workOutY = [];
    let productivityTrend = [];

    for (const date in stackedBarChartData) {
        let sum = stackedBarChartData[date]['Eat Meals'] + stackedBarChartData[date]['Go to Class'] +
                  stackedBarChartData[date]['Study'] + stackedBarChartData[date]['Walk the Dog'] +
                  stackedBarChartData[date]['Workout'];
        eatMealsY.push(stackedBarChartData[date]['Eat Meals']);
        goToClassY.push(stackedBarChartData[date]['Go to Class']);
        studyY.push(stackedBarChartData[date]['Study']);
        walkDogY.push(stackedBarChartData[date]['Walk the Dog']);
        workOutY.push(stackedBarChartData[date]['Workout']);
        productivityTrend.push(sum);
    }

    let traceEatMeals = {
        x: datesXAxis,
        y: eatMealsY,
        name: 'Eat Meals',
        type: 'bar'
    };
    let traceGoToClass = {
        x: datesXAxis,
        y: goToClassY,
        name: 'Go To Class',
        type: 'bar'
    };

    let traceStudy = {
        x: datesXAxis,
        y: studyY,
        name: 'Study',
        type: 'bar'
    };
    let traceWalkDog = {
        x: datesXAxis,
        y: walkDogY,
        name: 'Walk The Dog',
        type: 'bar'
    };
    let traceWorkout = {
        x: datesXAxis,
        y: workOutY,
        name: 'Workout',
        type: 'bar'
    };

    let traceDailyProductivity = {
        x: datesXAxis,
        y: productivityTrend,
        type: 'scatter',
        mode: 'lines+markers',
        marker: {color: 'blue'},
        name: 'Total Productivity'
    }

    const data = [traceEatMeals, traceGoToClass, traceStudy, traceWalkDog, traceWorkout, traceDailyProductivity];


    return (
        <div className="text-center">
            <Plot
                data={data}
                layout={ {barmode: 'stack', width: 750, height: 650, title: 'Your Journey With Us!'} }
            />
        </div>
    );

}